var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.info)?_c('v-list',{staticClass:"user-info"},[_c('v-list-item',[_c('AvatarBadge',{attrs:{"initials":_vm.info.initials,"email":_vm.info.email,"status":_vm.registrationStatusColor}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }